import { map, filter, keys, has, get } from "lodash";
import * as Objects from "@launchos/components/page";

export const objects = map(
  filter(keys(Objects), obj => has(Objects, `${obj}.settings`)),
  itm => get(Objects, `${itm}.settings`)
);